import { Mail, MapPin } from "lucide-react";

const LOGO_WHITE = "https://customer-assets.emergentagent.com/job_2f7e215b-21fb-4724-b9fe-01f573af4d89/artifacts/5qhmdlyg_Tailwind%20logo-Full-W.png";

export default function Footer() {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="site-footer" className="bg-[#0A1021]">
      {/* Main footer content */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Column 1: Logo & description */}
          <div className="lg:col-span-1">
            <img
              src={LOGO_WHITE}
              alt="Tailwind Corporation"
              className="h-16 w-auto mb-5"
              data-testid="footer-logo"
            />
            <p
              className="text-sm text-white/40 leading-relaxed"
              style={{ fontFamily: "Manrope, sans-serif" }}
              data-testid="footer-tagline"
            >
              Developing and operating business infrastructure within Jamaica's structured legal and operational environment.
            </p>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h4
              className="text-xs font-semibold tracking-[0.15em] uppercase text-[#D49A38] mb-5"
              style={{ fontFamily: "Manrope, sans-serif" }}
              data-testid="footer-links-heading"
            >
              Quick Links
            </h4>
            <ul className="space-y-3" style={{ fontFamily: "Manrope, sans-serif" }}>
              <li>
                <button onClick={() => scrollTo("framework")} className="text-sm text-white/50 hover:text-white/80 transition-colors" data-testid="footer-link-framework">
                  Framework
                </button>
              </li>
              <li>
                <button onClick={() => scrollTo("spaces")} className="text-sm text-white/50 hover:text-white/80 transition-colors" data-testid="footer-link-spaces">
                  Spaces
                </button>
              </li>
              <li>
                <button onClick={() => scrollTo("eleven41")} className="text-sm text-white/50 hover:text-white/80 transition-colors" data-testid="footer-link-projects">
                  Projects
                </button>
              </li>
              <li>
                <button onClick={() => scrollTo("team")} className="text-sm text-white/50 hover:text-white/80 transition-colors" data-testid="footer-link-team">
                  Team
                </button>
              </li>
              <li>
                <button onClick={() => scrollTo("contact")} className="text-sm text-white/50 hover:text-white/80 transition-colors" data-testid="footer-link-contact">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Column 3: Contact */}
          <div>
            <h4
              className="text-xs font-semibold tracking-[0.15em] uppercase text-[#D49A38] mb-5"
              style={{ fontFamily: "Manrope, sans-serif" }}
              data-testid="footer-contact-heading"
            >
              Contact
            </h4>
            <div className="space-y-4" style={{ fontFamily: "Manrope, sans-serif" }}>
              <div className="flex items-start gap-3">
                <MapPin className="h-4 w-4 text-[#D49A38] mt-0.5 shrink-0" />
                <p className="text-sm text-white/50 leading-relaxed" data-testid="footer-address">
                  Unit 28–30, Catherine Hall,<br />
                  Bogue Estate, Montego Bay,<br />
                  Saint James, Jamaica
                </p>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="h-4 w-4 text-[#D49A38] shrink-0" />
                <a
                  href="mailto:contactus@tailwindcorp.com"
                  className="text-sm text-white/50 hover:text-white/80 transition-colors"
                  data-testid="footer-email"
                >
                  contactus@tailwindcorp.com
                </a>
              </div>
              <p
                className="text-xs text-white/30 leading-relaxed mt-2 pl-7"
                style={{ fontFamily: "Manrope, sans-serif" }}
                data-testid="footer-license"
              >
                Tailwind Corporation (Jamaica) Limited is registered with the Real Estate Board of Jamaica license # DV/2110
              </p>
            </div>
          </div>

          {/* Column 4: Legal */}
          <div>
            <h4
              className="text-xs font-semibold tracking-[0.15em] uppercase text-[#D49A38] mb-5"
              style={{ fontFamily: "Manrope, sans-serif" }}
              data-testid="footer-legal-heading"
            >
              Legal
            </h4>
            <ul className="space-y-3" style={{ fontFamily: "Manrope, sans-serif" }}>
              <li>
                <a href="#" className="text-sm text-white/50 hover:text-white/80 transition-colors" data-testid="footer-link-privacy">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-white/50 hover:text-white/80 transition-colors" data-testid="footer-link-terms">
                  Terms &amp; Conditions
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-white/50 hover:text-white/80 transition-colors" data-testid="footer-link-cookies">
                  Cookies Policy
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Disclaimer + Copyright bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <p
            className="text-xs text-white/25 leading-relaxed mb-4"
            style={{ fontFamily: "Manrope, sans-serif" }}
            data-testid="footer-disclaimer"
          >
            The images and other details given on this website are indicative and the developer reserves the right to alter or amend the layout, plans, and specifications without prior notice or obligation.
          </p>
          <p
            className="text-xs text-white/30"
            style={{ fontFamily: "Manrope, sans-serif" }}
            data-testid="footer-copyright"
          >
            &copy; {new Date().getFullYear()} Tailwind Corporation (Jamaica) Limited. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
